module.exports = __webpack_public_path__ + "static/media/teebox-hex.ec7d1e39.png";